import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=447b1f15&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconDropArrow: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-drop-arrow/index.js').default})
